<ion-header>
  <ion-toolbar>
    <ion-title>{{'ios-install.label'| translate}} {{brand.title}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="ion-padding" *ngIf="browserName === 'safari'" [innerHTML]="'ios-install.instructions' | translate">
</div>

<div class="ion-padding" *ngIf="browserName !== 'safari'" [innerHTML]="'ios-install.note' | translate">
</div>
